import type { SimpleTableConfig } from "@/components/shared/UniversalCRMTable/types";

export const GRAPHQL_OPERATOR_KEYS = new Set([
  "eq", "neq", "in", "is", "gt", "gte", "lt", "lte",
  "like", "ilike", "regex", "iregex", "contains", "overlaps", "startsWith",
]);

export const GRAPHQL_LOGICAL_KEYS = new Set(["and", "or", "not"]);

export const CUSTOM_FILTER_FIELD_ALIASES: Record<string, string> = {
  clientId: "contact_id",
};

export function resolveGraphQLFieldName(key: string, entityName: string): string {
  const name = key.replace("filter_", "");
  if (name === "client") return "contact_id";
  if (name === "approval_status") return "is_approved";
  if (name === "billable_status") return "entry_type";
  if (entityName === "tickets" && name === "clientId") return "contact_id";
  return name;
}

export function convertArrayValueToGraphQL(
  value: string[],
  fieldName: string,
  entityName: string,
  config: SimpleTableConfig<any>
): Record<string, any> {
  // Contacts status: OR logic
  if (entityName === "contacts" && fieldName === "status") {
    if (value.length === 1) return { [fieldName]: { eq: value[0] } };
    return { or: value.map((val) => ({ [fieldName]: { eq: val } })) };
  }

  // JSONB technologies: OR contains logic
  if (fieldName === "current_technologies") {
    if (value.length === 1) return { [fieldName]: { contains: { [value[0]]: {} } } };
    return { or: value.map((tech) => ({ [fieldName]: { contains: { [tech]: {} } } })) };
  }

  const fieldConfig = (config.fields as any)?.[fieldName];
  const fieldType: string | undefined = fieldConfig?.type;
  const isStringListField =
    fieldType === "tags" || fieldType === "multi-user" || fieldType === "multiselect" ||
    fieldName.endsWith("_users") || fieldName.endsWith("_tags");

  if (isStringListField) return { [fieldName]: { overlaps: value } };
  return { [fieldName]: { in: value } };
}

export function buildRangeFilter(
  value: { min?: number; max?: number }
): Record<string, number> | null {
  const gte = value.min != null && !Number.isNaN(Number(value.min)) ? Number(value.min) : undefined;
  const lte = value.max != null && !Number.isNaN(Number(value.max)) ? Number(value.max) : undefined;
  if (gte === undefined && lte === undefined) return null;
  const result: Record<string, number> = {};
  if (gte !== undefined) result.gte = gte;
  if (lte !== undefined) result.lte = lte;
  return result;
}
